import styled from 'styled-components'

import {
  PB90T,
  WHITE,
  SLR,
  SG,
  SY,
  SLR70T,
  SG70T,
  SY70T,
  BLACK
} from '@h2/components/colors'
import { Box } from '@h2/components/layout/box'
import { Text } from '@h2/components/typography/text'
import { Button } from '@h2/components/buttons/button'

const hoverBgColors = {
  red: SLR70T,
  green: SG70T,
  yellow: SY70T
}
const hoverBorderColors = {
  red: SLR,
  green: SG,
  yellow: SY
}
const NextStepsChoiceWrap = styled(Button)`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${WHITE};
  border-radius: 5px;
  border-width: 1px;
  border-style: solid;
  border-color: ${PB90T};
  padding: 10px;
  flex-grow: 1;
  white-space: initial;
  text-align: center;
  :link {
    text-decoration: none;
  }

  :hover {
    cursor: pointer;
    background-color: ${({ color }) => hoverBgColors[color]};
    border-color: ${({ color }) => hoverBorderColors[color]};

    span {
      cursor: pointer;
    }
  }
`
const NextStepsChoice = ({ children, color, icon: Icon, ...rest }) => {
  return (
    <NextStepsChoiceWrap color={color} {...rest}>
      {Icon && <Icon size="large" />}
      <Box width="105px">
        <Text
          className="NextStepsChoice-Heading"
          size="medium"
          align="center"
          weight="bold"
          color={BLACK}
          removeMargins={true}>
          {children}
        </Text>
      </Box>
    </NextStepsChoiceWrap>
  )
}

export { NextStepsChoice }
